import React from "react";

export default class LearningPlanNavigation extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    //console.log("LearningPlanNavigation props", this.props);
    const { learning_plan, learning_plans = [], article } = this.props;
    const { learning_plan_sections = [], name } = learning_plan;
    const [learning_plan_section] = learning_plan_sections;
    const { learning_plan_items = [] } = learning_plan_section;

    var rendered_learning_plan_items = learning_plan_items.map(
      (learning_plan_item) => {
        if (learning_plan_item.learnable_type === "Course") {
          return this.renderCourse(learning_plan_item);
        } else if (learning_plan_item.learnable_type === "Exam") {
          return this.renderExam(learning_plan_item);
        }
      }
    );

    return (
      <div className="LearningPlanNavigationWrapper">
        <div className="LearningPlanNavigation CourseCollectionNavigation">
          <div className="CourseCollection">
            <div
              className="Name"
              dangerouslySetInnerHTML={{ __html: name }}
            ></div>
          </div>
          <div ref="courses">{rendered_learning_plan_items}</div>
        </div>

        {/* <div className="LearningPlanNavigationProgress">
          <div className="learning-plan-heading">
            <span className="learning-plan-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1em"
                viewBox="0 0 512 512"
              >
                <path
                  fill="rgba(255, 255, 255, 0.35);"
                  d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                />
              </svg>
            </span>
            <div className="learning-plan-name">{I18n.t("my_progress")}</div>
          </div>
          <div className="LearningPlans">
            {this.renderLearningPlansProgress(learning_plans)}
          </div>
        </div> */}
      </div>
    );
  }

  renderLearningPlansProgress(learning_plans) {
    return learning_plans.map((learning_plan) => {
      const { id, name, path, progress } = learning_plan;
      const calculated_progress = progress * 100;
      return (
        <a href={path} className="learning-plan" key={id}>
          <div className="name">{name}</div>
          <div className="learning-plan-item-progress">
            <div>
              <span className="learning-plan-label">{I18n.t("progress")}</span>
              <progress max="100" value={calculated_progress}>
                {calculated_progress}%
              </progress>
            </div>
          </div>
          <div className="chevron-right-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-chevron-right"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </div>
        </a>
      );
    });
  }

  renderArticle(article) {
    return (
      <a
        key={article.id}
        href={article.path}
        className={
          "Article " +
          (this.props.article && this.props.article.id === article.id
            ? " ActiveArticle "
            : "") +
          (article.is_viewed ? " ViewedArticle " : "") +
          (!this.props.article ? " ArticleDisabled" : "")
        }
        dangerouslySetInnerHTML={{
          __html: `${
            article.is_viewed
              ? '<div class="ViewedArticleCheckmark"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16"> <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/></svg></div>'
              : ""
          }${article.name}`,
        }}
      ></a>
    );
  }

  renderCourse(learning_plan_item) {
    const { learnable: course, path } = learning_plan_item;
    // var articles_length = course.articles.length;
    var articles = course.articles.map((article, idx) => {
      if (
        this.props.suppress_intros_and_summaries &&
        (idx === 0 || idx + 1 === articles_length)
      ) {
        // suppress
      } else {
        return this.renderArticle(article);
      }
    });

    return (
      <div
        key={course.id}
        className={
          "Course " + (this.props.course.id === course.id ? "CourseActive" : "")
        }
      >
        <a
          className="Name"
          href={path}
          dangerouslySetInnerHTML={{
            __html: `${course.name}`, //<div class="ContentLength">${articles_length}</div>
          }}
        ></a>
        <div
          className={
            "Articles " +
            (this.props.course.id === course.id ? "ArticlesActive " : " ")
          }
        >
          {articles}
        </div>
      </div>
    );
  }

  renderExam(learning_plan_item) {
    const { learnable: exam, path } = learning_plan_item;
    return (
      <div key={exam.id} className="Exam">
        <a
          href={path}
          className="Name"
          dangerouslySetInnerHTML={{ __html: exam.name }}
        ></a>
      </div>
    );
  }
}
